// @flow

import * as React from 'react';
import {Executable} from './_executable';
import {useStripeClui} from '../helpers/react/provider';

const Exit = () => {
  const {
    state: {panes, focusedPane},
    removePane,
    close,
    reset,
  } = useStripeClui();

  React.useEffect(() => {
    if (panes.length > 1) {
      removePane(focusedPane);
    } else {
      reset();
      close();
    }
  }, [close, focusedPane, panes.length, removePane, reset]);

  return '';
};

export class exit extends Executable {
  help(): React.Node {
    this.setAllowInput(true);
    return 'closes the shell';
  }

  run(): React.Node {
    this.setAllowInput(true);
    return <Exit />;
  }
}
